/**
 * Generates a checksum for the given input string. Defaults to SHA-1 algorithm.
 * @param input The input string to generate a checksum for.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
 * @returns The checksum as a hexadecimal string.
 */
export const generateChecksum = async (input: string, algorithm = 'SHA-1') => {
  return Array.from(new Uint8Array(await crypto.subtle.digest(algorithm, new TextEncoder().encode(input))))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};
